module.exports = __webpack_public_path__ + "assets/img/agence_services.d116ce2c.jpg";